import {
  Backdrop, CircularProgress, Grid, Typography,
} from '@mui/material';
import React from 'react';
import LeadFormLeftGrid from './LeadFormLeftGrid/redesign';
import LeadFormRightGrid from './LeadFormRightGrid/redesign';
import useStyles from './styles';
import { LeadFormIndexProps } from './types';

export default function LeadFormIndexRedesign(props: LeadFormIndexProps) {
  const {
    partner, error, loading, children, fullScreen, hideHero = false,
    plainSurface = false, projectHero = false, bare = false,
  } = props;
  const classes = useStyles();
  // bare: el paso dibuja su propio layout (PlrShell) a pantalla completa. Se mantiene
  // la misma estructura de árbol (Grid > LeftGrid > children) para no remontar el
  // formulario (y perder el paso actual) al pasar entre pasos con y sin PlrShell.
  let leftLg: number | undefined;
  if (fullScreen || bare) {
    leftLg = 12;
  } else if (projectHero) {
    leftLg = 7;
  }
  return (
    <Grid
      container
      className={classes.root}
    >
      <LeadFormLeftGrid
        xs={fullScreen || bare ? 12 : undefined}
        lg={leftLg}
        backgroundColor={plainSurface || bare ? '#fff' : undefined}
        bare={bare}
      >
        {children}
      </LeadFormLeftGrid>
      {!fullScreen && !bare && partner
      && (
      <LeadFormRightGrid
        partner={partner}
        hideHero={hideHero}
        projectCard={projectHero}
        lg={projectHero ? 5 : undefined}
      />
      )}
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
        {error && (
          <Typography color="inherit" maxWidth={450} marginTop={10}>
            Ha ocurrido un error en la verificación, por favor comienza de nuevo el flujo
            o contacte servicio al cliente
          </Typography>
        ) }
      </Backdrop>
    </Grid>
  );
}

LeadFormIndexRedesign.defaultProps = {
  fullScreen: undefined,
  hideHero: false,
  plainSurface: false,
  projectHero: false,
  bare: false,
};
